import reset from '!css-loader!../../styles/reset.css'
import defaultStyles from '!css-loader!../../styles/default.css'

export { default as theme } from './theme'

export default [reset, defaultStyles]
